import Vue from "vue";
import Router from "vue-router";
import Admin from "@/components/Admin";
import OrderByLikes from "@/components/OrderByLikes";
import TrashedPosts from "@/components/TrashedPosts";
import WordCloud from "@/components/WordCloud";
import Home from "@/components/Home";
import addBoardButton from "@/components/board/addBoardButton";
import Loading from "@/components/Loading";
import boardMeetingComponent from "@/components/board/boardMeetingComponent";
import PageNotFound from "@/components/PageNotFound";
import store from "@/store";
import VueSocketio from "vue-socket.io";

require('@/assets/css/styles.css')

// import VueSocketio from 'vue-socket.io-extended'
// import * as io from 'socket.io-client'
import "bulma-pageloader";
import Buefy, { ToastProgrammatic as Toast } from "buefy";

import i18n from "@/i18n";
import "buefy/dist/buefy.css";

import VueQriously from "vue-qriously";

Vue.use(Router);
Vue.use(Buefy, { defaultIconPack: "fa" });
Vue.use(VueQriously);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      beforeEnter: (to, from, next) => {
        if (to.params.error) {
          Toast.open({
            message: i18n.t(
              `error.code${to.params.errorMsg ? "." + to.params.errorMsg : ""}`
            ),
            duration: 4000,
            type: "is-danger",
            position: "is-bottom"
          });
        }
        next();
      }
    },
    {
      path: window.location !== window.parent.location ? "/board/p-:url_participant/:languageColidee" : "/board/p-:url_participant",
      name: "board",
      component: boardMeetingComponent,
      beforeEnter: (to, from, next) => {
        store.dispatch("board/checkparticipant", {
          url: to.params.url_participant
        });
        Vue.use(VueSocketio, process.env.NODE_SERVEUR);
        document.getElementsByTagName("html")[0].style.overflowX = "hidden";
        next();
      }
    },
    {
      path: "/board/a-:url_moderateur",
      name: "animer",
      component: boardMeetingComponent,
      beforeEnter: (to, from, next) => {
        store.dispatch("board/checkmoderateur", {
          url: to.params.url_moderateur
        });
        Vue.use(VueSocketio, process.env.NODE_SERVEUR);
        document.getElementsByTagName("html")[0].style.overflowX = "hidden";
        next();
      }
    },
    {
      path: "/cloud/:url_participant",
      name: "cloud",
      component: WordCloud,
      beforeEnter: (to, from, next) => {
        store.dispatch("board/checkparticipant", {
          url: to.params.url_participant
        });
        document.getElementsByTagName("html")[0].style.overflowX = "hidden";
        next();
      }
    },
    {
      path: "/like/:url_participant",
      name: "like",
      component: OrderByLikes,
      beforeEnter: (to, from, next) => {
        store.dispatch("board/checkparticipant", {
          url: to.params.url_participant
        });
        Vue.use(VueSocketio, process.env.NODE_SERVEUR);
        document.getElementsByTagName("html")[0].style.overflowX = "hidden";
        next();
      }
    },
    {
      path: "/trashcan/:url_participant",
      name: "trashcan",
      component: TrashedPosts,
      beforeEnter: (to, from, next) => {
        store.dispatch("board/checkparticipant", {
          url: to.params.url_participant
        });
        Vue.use(VueSocketio, process.env.NODE_SERVEUR);
        next();
      }
    },
    {
      path: "/tokenLogin",
      name: "tokenLogin",
      component: Loading,
      beforeEnter: (to, from, next) => {
        localStorage.clear();
        next();
      }
    },
    {
      path: "/admin",
      name: "Admin",
      component: Admin,
      beforeEnter: (to, from, next) => {
        localStorage.clear();
        store.commit("board/CLOSE_MEETING");
        if (store.getters["auth/isLoggedIn"] === true) {
          document.getElementsByTagName("html")[0].style.overflowX = "auto";
          next();
        } else {
          window.location = process.env.URL_SSO_FRONT;
        }
      }
    },
    {
      path: "/admin/board-configuration",
      name: "AdminConfig",
      component: addBoardButton,
      beforeEnter: (to, from, next) => {
        if (store.getters["auth/isLoggedIn"] === true) {
          document.getElementsByTagName("html")[0].style.overflowX = "auto";
          next();
        } else {
          window.location = process.env.URL_SSO_FRONT;
        }
      }
    },
    {
      path: "*",
      component: PageNotFound
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js